export default __webpack_public_path__ + "static/media/Reference.05a2e7b4.png";